// TODO: FranchiseIcon component used to be used in the blog widgets, but it's not used anymore.
// Once the blog widgets are removed, this component can be removed as well.

const FranchiseIcon = () => {
  return null;
};

export default FranchiseIcon;
